export default __webpack_public_path__ + "static/media/whoarewe - originals - dolamubadejo bdic 2.6d6e3e5c.png";